import React from "react";
import Footer from "../../components/Footer";
import Contact from "./Contact";
import Hero from "./Hero";
import Portfolio from "./Portfolio";
import Skills from "./Skills";

export default function Home() {
  return (
    <div className="bg-neutral-200 dark:bg-neutral-900 relative">
      <Hero />
      <Portfolio />
      <Skills />
      <div className="bg-[url('/src/assets/images/worldmap.svg')] bg-no-repeat bg-contain bg-neutral-200 bg-blend-color-burn dark:bg-neutral-900">
        <Contact />
        <Footer />
      </div>
    </div>
  );
}
